import md5 from 'md5';

const configMEGOGO = {
  host: 'https://api.megogo.net/v1',
  keys: {
    publicKey: '_volia_ua_smart',
    privateKey: '98a043507a',
  },
  endpoints: {
    stream: '/stream',
  },
  getSignedUrl: (params) => {
    const dataToSign = new URLSearchParams(params).toString().replace('&', '');
    params.sign = md5(dataToSign + configMEGOGO.keys.privateKey) + configMEGOGO.keys.publicKey;
    const requestParams = new URLSearchParams(params).toString();
    return configMEGOGO.host + configMEGOGO.endpoints.stream + '?' + requestParams;
  },
};

export default configMEGOGO;
